import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { PreferenceRoute, PreferencePathName } from '@/modules/ta/preference/preference.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${PreferenceRoute.PREFERENCES}`,
      name: PreferencePathName.PREFERENCES,
      component: () =>
        import(/* webpackChunkName: "preference-page" */ './pages/PreferencePage.vue'),
    },
  ],
  Module.PREFERENCE
);
